module.exports = __webpack_public_path__ + "img/bicycle.d866a54f.jpg";